'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaBehance = function FaBehance(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.9 9.2h-9.9v2.4h9.9v-2.4z m-4.9 8.3q-1.8 0-2.9 1t-1.2 2.7h8q-0.4-3.7-3.9-3.7z m0.3 11.3q1.2 0 2.4-0.6t1.4-1.7h4.3q-1.9 6-8.3 6-4.1 0-6.6-2.6t-2.4-6.7q0-4.1 2.5-6.7t6.5-2.7q2.7 0 4.7 1.3t3 3.5 1 4.8q0 0.3-0.1 0.9h-12.8q0 2.2 1.2 3.3t3.2 1.2z m-25.9-1h5.7q4 0 4-3.2 0-3.5-3.9-3.5h-5.8v6.7z m0-10.4h5.4q1.5 0 2.4-0.7t0.9-2.2q0-2.8-3.7-2.8h-5v5.7z m-5.4-9.9h11.5q1.7 0 3 0.3t2.5 0.9 1.7 1.9 0.7 3q0 3.5-3.4 5.1 2.2 0.6 3.4 2.2t1.1 4q0 1.4-0.5 2.6t-1.3 2.1-1.9 1.3-2.3 0.8-2.6 0.3h-11.9v-24.5z' })
        )
    );
};

exports.default = FaBehance;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/behance.js
// module id = 1371
// module chunks = 0